const HappyFace = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.4 0C3.76081 0 0 3.76081 0 8.4V61.6C0 66.2392 3.76081 70 8.4 70H61.6C66.2392 70 70 66.2392 70 61.6V8.4C70 3.76081 66.2392 0 61.6 0H8.4ZM18.2001 16.8C14.3341 16.8 11.2001 19.934 11.2001 23.8V46.2C11.2001 50.066 14.3341 53.2 18.2001 53.2H51.8001C55.6661 53.2 58.8001 50.066 58.8001 46.2V23.8C58.8001 19.934 55.6661 16.8 51.8001 16.8H18.2001Z"
      fill="black"
    />
    <circle cx="24.4995" cy="26.834" r="3.5" fill="black" />
    <circle cx="45.499" cy="26.834" r="3.5" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5 37C27.5 41.3262 31.0071 44.8333 35.3333 44.8333C39.6596 44.8333 43.1667 41.3262 43.1667 37H46.1667C46.1667 42.9831 41.3164 47.8333 35.3333 47.8333C29.3502 47.8333 24.5 42.9831 24.5 37H27.5Z"
      fill="black"
    />
  </svg>
);

export default HappyFace;
